<div class="app-container">
  <app-global-loading></app-global-loading>
  <div class="position-relative">
    <app-sidebar
      [isSidebarCollapsed]="isSidebarCollapsed"
      (sidebarToggle)="onSidebarToggle()"
    >
    </app-sidebar>
    <button
      class="sidebar-toggle-btn"
      [ngClass]="{ 'sidebar-collapsed': isSidebarCollapsed }"
      (click)="onSidebarToggle()"
    >
      <span *ngIf="!isSidebarCollapsed"
        ><i class="fa-solid fa-angle-left"></i
      ></span>
      <span *ngIf="isSidebarCollapsed"
        ><i class="fa-solid fa-angle-right"></i
      ></span>
    </button>
  </div>

  <main class="content" [ngClass]="{ 'content-expanded': isSidebarCollapsed }">
    <div class="content-inner"><router-outlet></router-outlet></div>
  </main>
</div>
